module.exports = __webpack_public_path__ + "img/button_press down_01.0d0d0201.png";